import React from 'react';
import styles from '../css/components/formrow.module.css';

export default function FormRow({ children, className = '' }) {
  return <div className={`${styles.row} ${className}`.trim()}>{children}</div>;
}
